'use client';

import { IcFailoverH72 } from '@yanolja-rnd/nol-icons';
import { EmptyState } from '@yanolja-rnd/nol-design-system';

interface FailoverProps {
  refetch: () => void;
  description?: string;
}

export const Failover = ({ refetch, description }: FailoverProps) => {
  return (
    <div className="mt-40 flex h-full w-full justify-center bg-colors-white">
      <EmptyState
        icon={IcFailoverH72}
        title="네트워크 연결 상태가 좋지 않아요"
        description={description || '연결 상태를 확인하고, 다시 시도해 주세요.'}
        pcType="pcLegacySize"
        buttons={[
          {
            content: '다시 시도하기',
            onClick: refetch,
          },
        ]}
      />
    </div>
  );
};
